/**
 * Encodes a string to base64, handling Unicode characters properly
 * @param str - The string to encode
 * @returns Base64 encoded string
 */
export const encodeBase64 = (str: string): string => {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (_, p1) =>
      String.fromCharCode(parseInt(p1, 16)),
    ),
  );
};
